import React from "react";
import ScrollSpy from "../common/scrollspy";
import AdInspire from "../components/ad/ad_01";

const SideScroll = () => {
  return (
    <div className="col-2 px-0 d-none d-lg-block scrollspy-container">
      <div style={{ position: "sticky", top: "80px" }}>
        <ScrollSpy></ScrollSpy>
        <AdInspire className="mt-4"></AdInspire>
      </div>
    </div>
  );
};

export default SideScroll;
